export default __webpack_public_path__ + "static/media/GraphIcon.477ecf21.svg";